import { useCallback } from "react";
import { useDashboardEditorContext } from "../../../../../../hook/context/editor";
import { useGUIEditorContext } from "../../../../../../hook/context/gui";

export const useLayerUpdateEncodingPositionCallback = (layerPosition: number) => {
  const editor = useDashboardEditorContext();
  const { block } = useGUIEditorContext();

  return useCallback(
    (position: "left" | "right") => {
      if (!block) return;
      void editor?.updateBlock({
        ...block,
        config: {
          ...block.config,
          layers: block.config.layers.map((layer, i) => ({
            ...layer,
            position: i === layerPosition ? position : layer.position,
          })),
        },
      });
    },
    [block, editor, layerPosition],
  );
};
